<div [formGroup]="formComponent" class="grid-x">
  <div class="cell">
    <label for="name">Name:</label>
    <input id="name" type="text" formControlName="name" required />
  </div>
  @if (name.invalid && (name.dirty || name.touched)) {
    <div class="error-container" class="cell">
      @if (name.errors.required) {
        <small class="error">Name is required.</small>
      }
      @if (name.errors.minlength) {
        <small class="error">Name must be at least 4 characters long.</small>
      }
    </div>
  }
  @if (!newItem) {
    <fieldset class="cell">
      <label for="allowNulls">
        Allow Nulls?
        <input id="allowNulls" type="checkbox" formControlName="allowNulls" [value]="allowNulls" />
      </label>
    </fieldset>
  }
  @if (newItem) {
    <div class="cell">
      <label for="itemType">
        Items Type:
        <select id="itemType" formControlName="itemType" required>
          @for (iT of itemTypes; track iT) {
            <option [value]="iT.value">{{iT.key}}</option>
          }
        </select>
      </label>
    </div>
  }
</div>